import BaseClient from '@/app/model/api/response/baseApiClient'

class SensorApi extends BaseClient {
  public getSensorData (plantingId: string, date: string) {
    const path = '/v1/field/sensor'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params

    if (date === 'all') {
      params = new URLSearchParams({ planting_id: plantingId, is_all: '1' })
    } else {
      params = new URLSearchParams({ planting_id: plantingId, date: date })
    }
    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new SensorApi()
